export interface CheckWaggleInterface {
  /**
   * 任务活动 ID
   */
  activityTaskId: number
  activityTaskName: string
  /**
   * 任务活动设置的批次名额总数
   */
  quota: number
  /**
   * 当前已导入的本次参与人总数
   */
  reflectionSum: number
}

export class CheckWaggle implements CheckWaggleInterface {
  /**
   * 任务活动 ID
   */
  activityTaskId: number
  activityTaskName: string
  /**
   * 任务活动设置的批次名额总数
   */
  quota: number
  /**
   * 当前已导入的本次参与人总数
   */
  reflectionSum: number

  constructor(props: CheckWaggleInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      activityTaskId: _activityTaskId,
      activityTaskName: _activityTaskName,
      quota: _quota,
      reflectionSum: _reflectionSum,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.activityTaskId = _activityTaskId
    this.activityTaskName = _activityTaskName
    this.quota = _quota
    this.reflectionSum = _reflectionSum
  }
}
